var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouyeLineEchart"},[_c('div',{staticClass:"sum"},[_vm._v(_vm._s(_vm.$tool.moneyFormatter(_vm.sum, 0)))]),_c('div',{staticClass:"dw"},[_vm._v("人份")]),_c('div',{staticClass:"echarts",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }